<template>
  <div class='core'>
    <div class='layui-fluid'>
      <pub-search
        :search-type="'add'"
        :tableObj='tableObj'
        :searchConfig='searchConfig'
        exportTemplate='报修表.xlsx'
      >
        <template>
          <button class="layui-btn layuiadmin-btn-role" @click="exportExcel()"><i class="layui-icon">&#xe67d;</i>导出</button>
<!--          <button class="layui-btn layuiadmin-btn-role" @click="toRepairsApproveHistoryViewOnClick()"><i class="layui-icon">&#xe62d;</i>审批记录</button>-->
        </template>
      </pub-search>
      <layui-table
        ref='repairManageMainViewRef'
        table-name='YW_REPAIRS'
        view-name='YW_REPAIRS_VIEW'
        :page-size='20'
        :page-range='6'
        :page-options='[10, 20, 50, 100]'
        :skin="'line'"
        :sort="['CREATE_TIME:DESC']"
        :defaultCondition="{'REPAIR_STATUS_ID:5': 2, 'REPAIR_STATUS_ID:10': 3, 'B_STORE_MANAGER_NO_PASS:0': 0}"
        :beforeRender='handleBeforeRender'
        @table-event-approve='approveOnClick($event)'
        @table-event-approve-history='approveHistoryOnClick($event)'
        @table-event-del='$refs.repairManageMainViewRef.delRows($event.data)'
      >
        <div>
          <div checkbox='true' align='center' fixed='left' width='60'></div>
          <layui-tableconfig :config='repairTableList'></layui-tableconfig>
          <div rowspan='3' align='center' fixed='right' title='操作' width='130'>
            <script type='text/html' v-pre>
              {{#  if(d.REPAIR_STATUS_ID == 2){ }}
              <a class='layui-btn-xs' lay-event='approve'>审核</a>
              {{#  } }}
              {{#  if(d.REPAIR_STATUS_ID != 2 && d.REPAIR_STATUS_ID != 1){ }}
              <a class='layui-btn-xs' lay-event='approve-history'>审核记录</a>
              {{#  } }}
            </script>
          </div>
        </div>

      </layui-table>
    </div>
  </div>
</template>
<script>

import "../../../utils/map/css/core.css"

export default {
  name: 'repairManageMainView',
  data () {
    return {
        repairTableList: [
          { field: 'repair_bill_code', title: '服务请求单编号', width: 180 },
          { field: 'repair_bill_ext_name', title: '报修单名称', width: 220 },
          { field: 'repair_type_ext_name', title: '报修分类', width: 150},
          { field: 'temp_contact_psn_ext_name', title: '联系人', width: 120},
          { field: 'temp_contact_psn_phone', title: '联系电话', width: 150},
          { field: 'store_name', title: '门店名称', width: 250},
          { field: 'repair_date', title: '报修时间', width: 180, sort: true},
          { field: 'custom_service_approve_status_name', title: '客服审核状态', width: 120},
          { field: 'problem_description', title: '问题描述', width: 300},
        ],
        tableObj: {
            checkedRows: 0,
            queryObject: {}
        },
        searchConfig: {
          basic: [
            {
              TYPE: 'input',
              WIDTH: 260,
              FIELD: 'REPAIR_BILL_CODE:2, REPAIR_BILL_EXT_NAME:2, REPAIR_TYPE_EXT_NAME:2, TEMP_CONTACT_PSN_EXT_NAME:2,' +
                     'TEMP_CONTACT_PSN_PHONE:2, STORE_NAME:2, CUSTOM_SERVICE_APPROVE_STATUS_NAME:2, PROBLEM_DESCRIPTION:2',
              PLACEHOLDER: '请输入查询条件'
            }
          ],
          advanced: [
            { TYPE:'input', NAME: '服务请求单编号 :', FIELD:'REPAIR_BILL_CODE:2', PLACEHOLDER: '请输入服务请求单编号'},
            { TYPE:'input', NAME: '报修单名称 :', FIELD:'REPAIR_BILL_EXT_NAME:2', PLACEHOLDER: '请输入报修单名称'},
            { TYPE:'input', NAME: '报修分类 :', FIELD:'REPAIR_TYPE_EXT_NAME:2', PLACEHOLDER: '请输入报修分类'},
            { TYPE:'input', NAME: '联系人 :', FIELD:'TEMP_CONTACT_PSN_EXT_NAME:2', PLACEHOLDER: '请输入联系人'},
            { TYPE:'input', NAME: '联系电话 :', FIELD:'TEMP_CONTACT_PSN_PHONE:2', PLACEHOLDER: '请输入联系电话'},
            { TYPE:'input', NAME: '门店名称 :', FIELD:'STORE_NAME:2', PLACEHOLDER: '请选择门店名称'},
            { TYPE:'date', NAME: '报修时间 :', FIELD:'REPAIR_DATE:2'},
            {
              TYPE: 'layui-multiselect',
              NAME: '客服审核状态:',
              FIELD: 'CUSTOM_SERVICE_APPROVE_STATUS_ID:1',
              textField: 'text',
              valueField: 'value',
              initData: this.dict.getData('CUSTOM_SERVICE_APPROVE_STATUS_ID')
            },
            { TYPE:'input', NAME: '问题描述 :', FIELD:'PROBLEM_DESCRIPTION:2', PLACEHOLDER: '请输入问题描述'},
          ],
          showBatch: false
        },
    }
  },
  mounted(){
    this.tableObj = this.$refs.repairManageMainViewRef;
  },

  methods: {
    approveOnClick(data) {
      this.baseComponent.smartLoadComponent('repairMngForm', {
        editRow: data.data,
        tableObj: this.tableObj,
        formType: 'approve',
        title: '报修审核'
      });
    },

    approveHistoryOnClick(data) {
      this.baseComponent.smartLoadComponent('repairApproveHistoryMainView', {
        editRow: data.data,
        tableObj: this.tableObj,
        formType: 'approve',
        title: '审核历史',
        repair_bill_id: data.data.REPAIR_BILL_ID
      });
    },

    handleBeforeRender(data) {
    },

    exportExcel() {
      let token = this.security.getToken()
      this.exportUrl = process.env.API_HOST + '/yw/repairManage/repairManageData'

      let formHtml = '<form  method="post" action="' + (this.exportUrl) + '" style="display:none;" accept-charset="UTF-8">'
      formHtml += '<input type="hidden" name="token"' + '" value="' + token + '">'
      formHtml += '</form>'

      $(formHtml).appendTo($('body')).submit()
    },

    toRepairsApproveHistoryViewOnClick() {
      this.baseComponent.smartLoadComponent('repairApproveHistoryMainView', {title: '审核历史'});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/repairs/repairManage/index.vue